import Facebook from './Facebook'
import axios from 'axios'

export default class User extends Facebook {
  constructor (user, parameters = null) {
    super(user)
    this.user = user
    this.parameters = parameters
  }
  getAccounts () {
    return axios({
      method: 'GET',
      url: `me/accounts`,
      params: {
        access_token: this.user.token
      }
    })
      .then(res => {
        return res.data.data
      })
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
  getAdAccounts () {
    return axios({
      method: 'GET',
      url: `me/adaccounts`,
      params: {
        access_token: this.user.token,
        fields: 'name'
      }
    })
      .then(res => {
        return res.data.data
      })
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
}
